/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function initQuickAddToCart() {
  const cartIcon = document.querySelector('a[data-action="open-drawer"]');
  const quickToCartForms = document.querySelectorAll('.quick-add-form form');
  const no_variants_btn = document.querySelectorAll(".no-variant");

  no_variants_btn.forEach((btn) => {
    const form = btn.closest("form");
    const nextElement = form.nextElementSibling;

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (nextElement.classList.contains('open')) {
        nextElement.classList.remove('open');
        const quickyForm = nextElement.querySelector("form");
        quickyForm.querySelector('input[type="radio"]').checked = true;

        const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
        quickyForm.dispatchEvent(submitEvent);

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        cartIcon?.click();
      }
    });
  });

  quickToCartForms.forEach((form) => {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const quickForm = event.currentTarget.closest(".quick-add-form");
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(error => {
              throw new Error(error.message || 'Something went wrong');
            });
          }
          return response.json();
        })
        .then(data => {
          console.log('Product added:', data);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          if (quickForm.classList.contains("open")) {
            quickForm.classList.remove("open");
            cartIcon?.click();
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          if (error.message.includes('Parameter Missing or Invalid')) {
            alert('No size selected. Please choose a size.');
          } else {
            alert(error.message || 'Failed to add product.');
          }
        });
    });
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initQuickAddToCart);

// Fallback in case Shopify section load works
document.addEventListener('shopify:section:load', initQuickAddToCart);

// 👇 This watches the product list container and re-runs logic when it's updated
const productListObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      initQuickAddToCart();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const productList = document.querySelector('.ProductListWrapper, .CollectionInner__Products');
  if (productList) {
    productListObserver.observe(productList, { childList: true, subtree: true });
  }
});



